<div>
    <span *ngIf="_edm.editing" class="inline">
        <span class="inline" style="font-size: 18px;">{{_adding ? "Adding a Creme Version" : "Editing a Creme Version" }}</span>
    </span>

    <editor-header [edm]="_edm" [customButtons]="true">
        <span customButtons class="inline" style="margin-left: 10px; margin-top: 6px;">
            <button *ngIf="!_edm.editing" type="button" class="btn btn-sm btn-primary" [disabled]="!canSave()" (click)="onSave()">Save</button>
            <button *ngIf="_edm.editing" type="button" class="btn btn-sm btn-primary" [disabled]="!canApply()" (click)="onApply()">Apply</button>
            <button *ngIf="canShowBack()" type="button" class="btn btn-sm btn-primary" (click)="onBack()">Back</button>
            <button *ngIf="canCancel()" type="button" class="btn btn-sm btn-primary" (click)="onCancel()">Cancel</button>
        </span>
    </editor-header>
    <span *ngIf="(!_edm.editing)">
        <button type="button" class="inline btn-sm btn-primary" style="width: 170px;" (click)="onAdd()">Add Creme Version</button>
    </span>
</div>
<div class="" *ngIf="_validationMessage">
    <p class="alert-danger">{{_validationMessage}}</p>
</div>
<br />
<div [attr.data-hidden]="_edm.editing">
    <div *ngIf="_typeCremeVersionsEx && _typeCremeVersionsEx.length">
        <div style="border: 1px solid black; width: 640px;">
            <div class="scrollableTableHeader">
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 55px">Edit</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 75px">Remove</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 140px">Creme Version</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 280px">Notes</span></div>
            </div>
            <div style="height: 240px; overflow-y:auto;overflow-x: hidden;">
                <div class="scrollableTableRow" *ngFor="let c of _typeCremeVersionsEx"
                     [ngStyle]="{ 'background-color': c.backgroundColor }">
                    <div class="scrollableTableColumn text-center"><a class="inline" style="width: 55px" (click)="onEdit(c)">Edit</a></div>
                    <div class="scrollableTableColumn text-center"><a class="inline" style="width: 75px" (click)="onRemove(c)">Remove</a></div>
                    <div class="scrollableTableColumn text-center"><span class="inline" style="width: 140px">{{c.data.cremeVersion}}</span></div>
                    <div class="scrollableTableColumn text-center"><span class="inline" style="width: 280px">{{c.data.description}}</span></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="_edm.editing">
    <type-creme-version-editor #self [entity]="_edm.currentEntity"></type-creme-version-editor>
</div>

<confirm-finish-override-dialog></confirm-finish-override-dialog>
